import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getABooking,
  resetState,
  submitFeedback,
  updateABooking,
} from "../features/booking/bookingSlice";
import { BiArrowBack } from "react-icons/bi";
import * as yup from "yup";
import { useFormik } from "formik";

const contactSchema = yup.object({
  feedback: yup.string().default('').nullable().required("Feedback is Required."),
  name: yup.string().required("Staff Member Name is Required."), // Add validation for staff member name
});

const ViewBooking = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const getBookingId = location.pathname.split("/")[3];
    const bookingState = useSelector((state) => state.booking);
    console.log(getBookingId,"bokking id")
    console.log(bookingState, "Booking State");
  
    const booking = bookingState?.bookings?.find(b => b._id === getBookingId) || bookingState?.bookings?.[0];
  
 
    useEffect(() => {
      dispatch(getABooking(getBookingId));
    }, [getBookingId, dispatch]);
  
    const goBack = () => {
      navigate(-1);
    };
  
    const setBookingStatus = (e, i) => {
    
      const data = { id: i, bookingData: e };
      console.log(data,"dta")
      dispatch(updateABooking(data));
       
    
      setTimeout(() => {
        dispatch(getABooking(getBookingId));
      }, 100);
    };
    

  

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="mb-4 title">View Booking</h3>
        <button
          className="bg-transparent back-button border-0 fs-6 mb-0 d-flex align-items-center gap-1"
          onClick={goBack}
        >
          <BiArrowBack className="fs-5 back-icon" /> Go Back
        </button>
      </div>
      <div className="view-booking-wrapper">
        <div className="view-booking-content">
          <div className="bg-white p-4 d-flex gap-3 flex-column rounded-3">



    {/* Vehicle Details Table */}
    <h4>Vehicle Details</h4>
    <table className="table table-bordered">
      <tbody>
        <tr>
          <th>Make</th>
          <td>{booking?.make}</td>
        </tr>
        <tr>
          <th>Model</th>
          <td>{booking?.model}</td>
        </tr>
        <tr>
          <th>Year</th>
          <td>{booking?.year}</td>
        </tr>
     
     
   
        <tr>
          <th>Location</th>
          <td>{booking?.location}</td>
        </tr>
      </tbody>
    </table>
    <h4>User Details</h4>
    <table className="table table-bordered">
      <tbody>
      <tr>
          <th>Seller Type</th>
          <td>{booking?.selectedSeller}</td>
        </tr>
        <tr>
          <th>Name</th>
          <td>{booking?.name}</td>
        </tr>
        <tr>
          <th>Mobile</th>
          <td>
            <a href={`tel:${booking?.mobile}`}>{booking?.mobile}</a>
          </td>
        </tr>
        <tr>
          <th>Email</th>
          <td>
            <a href={`mailto:${booking?.email}`}>{booking?.email}</a>
          </td>
        </tr>
        <tr>
          <th>Contact Method</th>
          <td>{booking?.contactMethod}</td>
        </tr>
      </tbody>
    </table>

    <div className="d-flex flex-wrap gap-3 id-container">
    <div className="id-card">
            <h3>Id Front</h3>
        {booking?.images?.map((img, index) => (
                  <img key={index} src={img.url} alt={`Vehicle ${index + 1}`} />
                ))}
        </div>
        <div className="id-card">
            <h3>Id Back</h3>
        {booking?.descImages?.map((img, index) => (
                  <img key={index} src={img.url} alt={`Vehicle ${index + 1}`}  />
                ))}
        </div>
 
  
              </div>
  
      
      
            <div className="d-flex mt-5 align-items-center gap-3">
              <h6 className="mb-0">Change Status:</h6>
              <div>
                <select
                  value={booking?.status || "Submitted"} // Use value instead of defaultValue
                  className="form-control form-select"
                  onChange={(e) => setBookingStatus(e.target.value, getBookingId)}
                >
                  <option value="Submitted">Submitted</option>
                  <option value="Contacted">Contacted</option>
               </select>
              </div>
            </div>
          </div>
        </div>
      
      </div>
    </div>
  );
};

export default ViewBooking;



 
  